/**
 * Converts a data URI to a file.
 *
 * @param dataUri The data URI scheme.
 * @param filename The name of the file.
 * @param lastModified The date of when the file was last modified.
 */
export async function dataUriToFile(
  dataUri: string,
  filename: string,
  lastModified = new Date(),
): Promise<File> {
  const blob = await fetch(dataUri).then((response) => response.blob());

  return new File([blob], filename, {
    lastModified: lastModified.valueOf(),
    type: blob.type,
  });
}
